import React from 'react'
import styled, { css } from 'styled-components'
import ReactHtmlParser from 'react-html-parser'

import { convertContent } from '@libs/postTools'

import PopTime from '../../PopTime'

import { Comment } from './index'
import { imageUrl } from '@libs/appUrl'
import { useTranslation } from '@i18n'

const IndentContainer = styled.div`
  margin-top: -2px;
  margin-left: 40px;
`

const User = styled.div`
  display: flex;
  line-height: 30px;
  color: #2f2f2f;
  font-size: 0.9rem;

  amp-img {
    border-radius: 50%;
    margin-right: 10px;
  }
`

const P = styled.p`
  line-height: 1.6;
`

const Footer = styled.div`
  font-size: 0.9em;
  padding: 7px 0 10px;
  color: #ababab;
  display: flex;
  justify-content: space-between;
`

const LikeContainer = styled.a`
  display: flex;
  align-items: center;
`

const Like = styled.div`
  margin-left: 3px;
`

const subStyle = css`
  background-color: #f7f8fa;
  padding: 15px 10px 15px 15px;
  margin-right: 5px;

  ${IndentContainer} {
    margin-top: 0px;
    margin-left: 0px;
  }

  ${User} {
    line-height: 25px;
    margin-bottom: 8px;
  }

  ${Footer} {
    padding: 10px 0 0;
  }
`

const Container = styled.div<{ isSub: boolean }>`
  padding-top: 10px;

  ${(props) => props.isSub && subStyle}
`

type Props = {
  comment: Comment
  subComments?: Comment[]
  url: string
}

function CommentItem(props: Props) {
  const { comment, subComments, url } = props
  const { text, t: timestamp, userInfo, like } = comment
  const { img, name } = userInfo
  const { t } = useTranslation()

  const isSub = !subComments
  const avatarSize = isSub ? '25' : '30'

  return (
    <Container isSub={isSub}>
      <User>
        <amp-img
          src={imageUrl(img)}
          width={avatarSize}
          height={avatarSize}
          style={{ borderRadius: '50%' }}
        />
        <span>{name}</span>
      </User>
      <IndentContainer>
        <a href={url}>
          <P>{ReactHtmlParser(convertContent(text))}</P>
        </a>
        <Footer>
          <PopTime className="commend-cube-stats-time" time={timestamp} />
          <LikeContainer href={url}>
            <div>{`${t('post:回覆')}・`}</div>
            <amp-img src={imageUrl('img/globalicon/like01.png')} width="18" height="18" />
            <Like>{like}</Like>
          </LikeContainer>
        </Footer>
        {subComments && (
          <>
            {subComments.map((subComment, idx) => (
              <CommentItem key={idx} url={url} comment={subComment} />
            ))}
          </>
        )}
      </IndentContainer>
    </Container>
  )
}

export default CommentItem
